import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-681c660c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "account" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col--12 column main" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col--12" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col--12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_BaseSection = _resolveComponent("BaseSection")!
  const _component_AccountHeader = _resolveComponent("AccountHeader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.accountLoading)
        ? (_openBlock(), _createBlock(_component_BaseSection, {
            key: 0,
            class: "account__spinner"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_BaseSpinner)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_Transition, {
            name: "fade",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_ctx.loading)
                ? (_openBlock(), _createBlock(_component_BaseSection, {
                    key: 0,
                    class: "spinner"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_BaseSpinner)
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_Transition, {
                    key: 1,
                    name: "slide",
                    mode: "out-in"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_AccountHeader)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.activeComponent)))
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}